import { useEffect, useRef } from "react";

// An open dropdown takes Escape before its Drawer does: listened to in the
// capture phase, it closes itself and marks the event handled, which the
// Drawer then ignores (otherwise Escape would close the whole form). Only one
// layer closes per Escape.
const useCloseOnEscape = (open, close) => {
  const closeRef = useRef(close);
  closeRef.current = close;
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key !== "Escape" || e.defaultPrevented) return;
      e.preventDefault();
      closeRef.current();
    };
    document.addEventListener("keydown", onKeyDown, true);
    return () => document.removeEventListener("keydown", onKeyDown, true);
  }, [open]);
};

export default useCloseOnEscape;
